import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'contains'
})
export class ContainsPipe implements PipeTransform {
    transform(contents: string[], value: string): boolean {
        return contents?.some(x => x === value);
    }
}
